import { render, staticRenderFns } from "./SwiperReports.vue?vue&type=template&id=5bc3a9b6&"
import script from "./SwiperReports.vue?vue&type=script&lang=js&"
export * from "./SwiperReports.vue?vue&type=script&lang=js&"
import style0 from "./SwiperReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports